<!--
 Copyright 2022 by domX Private Company

 All rights reserved,
 also regarding any disposal, exploitation, reproduction,
 editing, distribution, as well as in the event of
 applications for industrial property rights.

 This software contains proprietary and confidential
 information of domX Private Company.
 The disclosure of confidential information without
 express authorization is prohibited.

 This software may include Open Source Software.
 As far as Open Source Software is included,
 your rights for the respective Open Source Software
 components are governed by the applicable
 Open Source Software licenses.
-->

<template class="fill-height">    
  <v-card
      flat
      class="secondary fill-height pa-12"
      height="25%">
    <v-form
      v-if="currInstallation"
      ref="form"
      lazy-validation
    >
      <v-list class="secondary" max-width="1000px">
        <v-subheader class="display-1 grayBold--text">
          {{$t("edit_device")}}
        </v-subheader>
        <v-list-item>
          <v-list-item-content class="grayBold--text">
            <v-list-item-title class="subtitle-2 grayBold--text">

            </v-list-item-title>
              <v-flex xs12 sm6 md6 v-if="!payload.installation">
                <v-autocomplete
                  light
                  class="grayBold--text mr-5"
                  v-model="deviceModel.installation_id"
                  prepend-inner-icon="mdi-home-search"
                  :items="allInstallations"
                  :item-text="installationText"
                  item-value="id"
                  :label="$t('installation')"
                  required
                  :loading="isLoadingInstallations"
                  :disabled="isLoadingInstallations"
                  :rules="installationRule"
                >
                  <template v-slot:selection="data">
                    <v-chip
                      v-bind="data.attrs"
                      small
                      :input-value="data.selected"
                      class="black--text"
                      @click="data.select"
                      @click:close="remove(data.item)"
                      >
                      {{ data.item.is_business ? `${data.item.tag_id.split('_').pop()} | ${data.item.address} | ${data.item.entity_name} (${data.item.client_name}) | ${data.item.phone}`
                      : `${data.item.tag_id.split('_').pop()} | ${data.item.address} | ${data.item.client_name} | ${data.item.phone}` }}
                    </v-chip>
                  </template>
                  <template v-slot:no-data>
                    <div class="px-4">{{ $t('comboNoData') }}</div>
                  </template>
                </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field disabled light v-model="deviceModel.device_id" append-icon="mdi-cellphone-cog" :label="$t('device_id')" />
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field class="mr-5" light v-model="deviceModel.device_name" :label="$t('device_friendly_name')" />
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-autocomplete
                  light
                  class="grayBold--text mr-5"
                  v-model="deviceModel.hvac_model_id"
                  :items="hvacItemModels"
                  item-text="brand_model"
                  item-value="model_id"
                  :label="$t('hvac_brand')"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-textarea
                  light
                  v-model="deviceModel.notes"
                  :label="$t('notes')"
                  auto-grow
                  append-icon="mdi-text-box-edit-outline"
                  rows="1"
                  :counter="1000"
                  :rules="notesRule"/>
                </v-flex>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          depressed
          right
          light
          color="grayBold--text secondary"
          @click="hideModal()"
        >
          {{$t("cancel")}} 
        </v-btn>
        <v-btn
          color="primary"
          depressed
          right
          large
          class="modal-update"
          @click="doUpdateDevice"><v-icon left>mdi-pencil</v-icon>{{$t("save")}}</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import { commonModule, installationsModule, devicesModule, companyModule, itemsModule } from '@/store/modules/store-accessor'


@Component
export default class EditDeviceModal extends Vue {
  @Prop()
  payload!: any;

  loadingInstallations = true;

  get currInstallation () {
    return installationsModule.currentInstallation;
  }

  get currDevice () {
    return devicesModule.currentDevice;
  }

  get allInstallations() {
    return commonModule.installationsCombo;
  }

  get isLoadingInstallations () {
    return this.loadingInstallations;
  }
  get installationDescriptionIsEnabled() {
    return (companyModule.company?.preferences as any)?.installation_description;
  }

  get hvacItemModels() {
    return itemsModule.hvacItemModels;
  }
 
  deviceModel = {
    installation_id: this.currInstallation.info.id,
    device_id: this.currDevice.data.deviceId || '',
    device_name: this.currDevice.info.device_name || null,
    notes: this.currDevice.info.notes || null,
    hvac_model_id: this.currDevice.info.hvac_model_id || null,
  }

  google_address:any;

  evt:any;

  tagRule= [
    (val: any) => !!val || this.$i18n.t("tag_required"),
  ]
  clientRule= [
  (val: any) => ((!!val || val == '') && val.name.length > 0) || this.$i18n.t("client_required"),
  ]

  areaRule= [
    (val: any) => !!val || this.$i18n.t("area_required"),
    (val: any) => val.length <= 30 || this.$i18n.t("form_area_length_rule"),
  ]

  installationRule = [
    (val: any) => !!val || this.$i18n.t("installation_required"),
  ]

  zipCodeRule= [
    (val: any) => val.length <= 15 || this.$i18n.t("form_zipCode_length_rule"),
  ]
  notesRule= [
    (val: any) => {
      if(val != null) return val.length <= 1000 || this.$i18n.t("form_notes_length_rule");
      else return true;
    },
  ]

  //Add Validation for two 



  installationText(item: any) {
    let installation_arr = item.is_business 
    ?
    [item.tag_id.split('_').pop(), `${item.address ? item.address : item.area }`, (item.description && this.installationDescriptionIsEnabled) ? item.description : '', `${item.entity_name} (${item.client_name})`, item.phone]
    :
    [item.tag_id.split('_').pop(), `${item.address ? item.address : item.area }`,(item.description && this.installationDescriptionIsEnabled) ? item.description : '', item.client_name, item.phone]

    return installation_arr.filter(Boolean).join(' | ')
  }

  async hideModal () {
    commonModule.hideModal();
  }

  async doUpdateDevice () {
    if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
      await devicesModule.editDevice(this.deviceModel);
      devicesModule.getDeviceInfo(this.deviceModel.device_id);
      devicesModule.getDevices(devicesModule.filters);
      this.hideModal();  
    }
  }

  async mounted() {
    commonModule.initSnackbar({});
    this.loadingInstallations = true;
    await commonModule.getInstallationsCombo();
    this.loadingInstallations = false;
    itemsModule.getAllHVACItemModels('');
  }

  isNumber(evt:any) {
      evt = evt || window.event;
      let charCode = evt.which || evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
      return false;
  }
};
</script>

